import TagManager from 'react-gtm-module'

export const sendDataLayer = (event: string, location: string) => {
	TagManager.dataLayer({
		dataLayer: {
			event,
			category: event,
			action: event,
			label: location,
		},
	})
}
